export interface IToastState {
    open: boolean;
    status: 'error' | 'info' | 'success' | 'warning';
    message: string;
}

export const defaultToastState: IToastState = {
    open: false,
    status: 'success',
    message: '',
};
